export default __webpack_public_path__ + "static/media/breadcrumb-cansho.78d866a4.png";